import script from "./AssessmentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentList.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentList.vue?vue&type=style&index=0&id=1c498617&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c498617"]])

export default __exports__